//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["n_business_modifiers"],"GetBusinessModifiers",{R_:{business_modifiers:"Annotations.BusinessModifier[]"}},0,0],[["business_modifiers"],"SetBusinessModifiers",{},1,0],[[],"GetAssociatedObject",{R_:{assoc_obj:"Annotations.AssociatedObject"}},0,0],[["assoc_obj"],"SetAssociatedObject",{},1,0],[[],"GetIndex",{R_:{index:''}},0,0],[["index"],"SetIndex",{},1,0],[[],"GetNumAssociatedObjectsSets",{R_:{numAssocObjectsSets:''}},0,0],[["numAssocObjectsSets"],"SetNumAssociatedObjectsSets",{},1,0]],[]];
SPLM.Annotations.PmiData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PmiData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;